import { render, staticRenderFns } from "./PostBody.vue?vue&type=template&id=32f03530&scoped=true&"
import script from "./PostBody.vue?vue&type=script&lang=js&"
export * from "./PostBody.vue?vue&type=script&lang=js&"
import style0 from "./PostBody.vue?vue&type=style&index=0&id=32f03530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f03530",
  null
  
)

export default component.exports